import React from 'react';
import 'styles/chat/ReportMessagePopup.css';
import {postReportMessage} from 'util/api';
import {usePopup} from 'popup/PopupContext';

function ReportMessagePopup({msg, type}) {
    const {closePopup} = usePopup();

    const handleSubmit = async (event) => {
        event.preventDefault();
        const category = event.target.elements.category.value;
        const description = event.target.elements.description.value;

        try {
            await postReportMessage(msg.id, category, description, type);
            closePopup();
        } catch (error) {
            console.error('Error sending report:', error);
        }
    };

    const onClose = () => {
        closePopup();
    };

    return (
        <div className="modal-content">
            <h2 style={{marginTop: '0', paddingLeft: '10px'}}>Report Message {msg.message}</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    Category:
                    <select name="category">
                        <option value="personal-abuse">Personal Abuse</option>
                        <option value="advertisement">Advertisement</option>
                        <option value="propaganda">Political Propaganda</option>
                        <option value="hate-speech">Hate Speech</option>
                        <option value="spam">Spam</option>
                        <option value="other">Other</option>
                    </select>
                </label>
                <label>
                    Description:
                    <textarea name="description" required></textarea>
                </label>
                <button type="submit">Submit</button>
                <button type="button" onClick={onClose}>Cancel</button>
            </form>
        </div>
    );
}

export default ReportMessagePopup;